import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";
import { t } from "i18next";
import { TableLoader } from "../molecules/TableLoader";
import { Button } from "../atoms/Button";

export type HistoryTableProps = {
  isLoading: boolean;
  agreements: any[];
  onDownloadTicket: (transaction: any) => void;
};

export const HistoryTable: React.FC<HistoryTableProps> = ({
  isLoading,
  agreements,
  onDownloadTicket,
}) => {
  console.log("agreements de history", agreements);

  return (
    <div className="flex-1 overflow-scroll flex flex-col border">
      <div className="flex flex-1 flex-col">
        {isLoading ? (
          <TableLoader columns={7} />
        ) : (
          <Fragment>
            {agreements.length === 0 ? (
              <Empty texto={t("transaction.views.no_task")} />
            ) : (
              <Fragment>
                <table className="divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("User id	")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("Id")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("Estado")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("Usuario")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("Concepto")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("Fecha pago")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("Total")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {agreements.map((agreement: any) => (
                      <tr key={agreement.id}>
                        <ColumnText wrap title={`${agreement.userId}`} />
                        <ColumnText wrap title={agreement.stsId} />
                        <ColumnText
                          wrap
                          title={
                            agreement.payment === 1
                              ? t("direct_debit.views.enable_history_ACCC")
                              : agreement.payment === 0 &&
                                  agreement.status_aux === "Payment declined"
                                ? t("direct_debit.views.enable_history_RJCT")
                                : t("direct_debit.views.enable_history_PDNG")
                          }
                        />
                        <ColumnText wrap title={agreement.userName} />
                        <ColumnText
                          wrap
                          title={t(`direct_debit.views.${agreement.type}`)}
                        />
                        <ColumnText
                          wrap
                          title={
                            agreement.dateSepa
                              ? new Date(
                                  agreement.dateSepa
                                ).toLocaleDateString()
                              : new Date(
                                  agreement.createdAt
                                ).toLocaleDateString()
                          }
                        />
                        <ColumnText
                          wrap
                          title={Number(agreement.price).toFixed(2)}
                        />
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default HistoryTableProps;
